import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
import { AssetDb } from "../resource/AssetDb";
import { Browser } from "../utils/Browser";
import { Handler } from "../utils/Handler";
import { SoundManager } from "./SoundManager";
export class SoundChannel extends EventDispatcher {
    constructor(url) {
        super();
        this.playbackRate = 1;
        this._started = false;
        this._paused = false;
        this._loaded = false;
        this._completed = false;
        this._repeated = 0;
        this._volumeSet = 1;
        this._volume = 1;
        this._muted = false;
        this._startTime = 0;
        this._pauseTime = 0;
        this._isMusic = false;
        this._autoResume = false;
        this.url = url;
    }
    get volume() {
        return this._volumeSet;
    }
    set volume(value) {
        this._volumeSet = value;
        let t = value * (this._isMusic ? SoundManager.musicVolume : SoundManager.soundVolume);
        if (t !== this._volume) {
            this._volume = t;
            if (this._loaded)
                this.onVolumeChanged();
        }
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        value = !!value;
        if (this._muted == value)
            return;
        this._muted = value;
        if (this._loaded)
            this.onMuted();
    }
    get position() {
        if (this._paused)
            return this._pauseTime;
        else if (this._startTime != 0)
            return (Browser.now() - this._startTime) / 1000 + this.startTime;
        else
            return this.startTime;
    }
    get duration() {
        return 0;
    }
    get paused() {
        return this._paused;
    }
    get isStopped() {
        return !this._started;
    }
    play() {
        if (this._started) {
            if (this._paused)
                this.resume();
            return;
        }
        this._started = true;
        this._loaded = false;
        this._completed = false;
        this._repeated = 0;
        this._startTime = Browser.now();
        SoundManager.addChannel(this);
        AssetDb.inst.resolveURL(this.url, url => {
            if (!this._started)
                return;
            if (!url) {
                this.stop();
                return;
            }
            this.onPlay(url);
        });
    }
    stop() {
        if (!this._started)
            return;
        this._started = false;
        this._loaded = false;
        SoundManager.removeChannel(this);
        this.onStop();
        this.callComplete(this._completed);
    }
    pause() {
        if (!this._started || this._paused)
            return;
        this._pauseTime = this.position;
        this._paused = true;
        this._autoResume = false;
        if (this._loaded)
            this.onPause();
    }
    resume() {
        if (!this._started || !this._paused)
            return;
        this._paused = false;
        if (this._loaded)
            this.onResume();
    }
    onPlay(url) {
    }
    onPlayAgain() {
    }
    onStop() {
    }
    onPause() {
    }
    onResume() {
    }
    onVolumeChanged() {
    }
    onMuted() {
    }
    onPlayEnd() {
        this._repeated++;
        if (this.loops > 0 && this._repeated >= this.loops) {
            this._completed = true;
            this.stop();
        }
        else
            this.onPlayAgain();
    }
    callComplete(success) {
        if (success)
            this.event(Event.COMPLETE);
        if (!this.completeHandler)
            return;
        let handler = this.completeHandler;
        this.completeHandler = null;
        if (handler instanceof Handler)
            handler.runWith(success !== null && success !== void 0 ? success : true);
        else
            handler(success !== null && success !== void 0 ? success : true);
    }
}
